import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import ENDPOINT from '../../context/EndPoint';
import DeleteIcon from '@mui/icons-material/Delete';
import { Edit, MoreVert } from '@material-ui/icons';
import { Box, Modal } from '@material-ui/core';
import { Dropdown, Toast } from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import ModalStyle from '../../context/ModalStyle';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const CourseTopicsManagement = () => {
  const params = useParams();
  const course_url = params.course_url;
  const chapter_id = params.chapter_id;
  const [topics, setTopics] = useState(null);
  const { user } = useContext(AuthContext);
  const [edit, setEdit] = useState(false);
  const [currentTopic, setCurrentTopic] = useState(null);
  const [total, setTotal] = useState(0);
  const [topicId, setTopicId] = useState(null);
  const [ctTitle, setCtTitle] = useState(null);
  const [coverPic, setCoverPic] = useState(null);
  const [add, setAdd] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastTitle, setToastTit] = useState('');
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [ctId, setCtId] = useState(null);

  const getTopics = async () => {
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('course_url', course_url);
    formData.append('chapter_id', chapter_id);

    const res = await axios.post(ENDPOINT + 'admin-get-topics.php', formData, {
      headers: { 'content-type': 'multipart/form-data' },
    });
    if (res && res.data.status === 'success') {
      setTopics(res.data.data);
      setTotal(res.data.data ? res.data.data.length : 0);
    }
  };

  const addTopicDB = async () => {
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('course_url', course_url);
    formData.append('chapter_id', chapter_id);
    formData.append('topic_title', ctTitle);
    formData.append('topic_id', ctId);
    formData.append('cover_pic', coverPic);
    if (file) formData.append('resume', file);

    const res = await axios.post(ENDPOINT + 'admin-add-topic.php', formData, {
      headers: { 'content-type': 'multipart/form-data' },
    });
    if (res && res.data.status === 'success') {
      getTopics();
      setCtTitle('');
      setFile(null);
      setCtId(total + 1);
    }
  };

  const EditTopic = async ({ payload }) => {
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('topic_id', topicId);
    formData.append('topic_title', ctTitle);
    if (payload.cover_pic) formData.append('resume', file);
    formData.append('course_url', course_url);

    const res = await axios.post(ENDPOINT + 'admin-edit-topic.php', formData, {
      headers: { 'content-type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percentCompleted);
      },
    });
    if (res && res.data.status === 'success') {
      getTopics();
      setToastTit('Edited successfully');
      setToast(true);
    }
  };

  const deleteTopic = async ({ topic }) => {
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('topic_id', topic.id);

    const res = await axios.post(ENDPOINT + 'admin-delete-topic.php', formData, {
      headers: { 'content-type': 'multipart/form-data' },
    });
    if (res && res.data[0].status === 'success') {
      getTopics();
      setCtTitle('');
      setCtId(total + 2);
    }
  };

  const StartEdit = (topic_id, index) => {
    setTopicId(topic_id);
    setCurrentTopic(index);
    setCtTitle(topics[index].topic_title);
    setCoverPic(topics[index].cover_pic);
    setEdit(true);
  };

  const addTopic = () => {
    const totalTopics = topics ? topics.length + 1 : 0;
    setCurrentTopic(totalTopics + 1);
    setCtTitle('');
    setCtId(totalTopics + 1);
    setAdd(true);
  };

  const onChange = (e) => setFile(e.target.files[0]);

  // Drag-and-Drop handler
  const onDragEnd = async (result) => {
    if (!result.destination) return;
  
    const reorderedTopics = Array.from(topics);
    const [movedTopic] = reorderedTopics.splice(result.source.index, 1);
    reorderedTopics.splice(result.destination.index, 0, movedTopic);
    setTopics(reorderedTopics);
  
  
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('course_url', course_url);
    formData.append('chapter_id', chapter_id);
    formData.append('topics', JSON.stringify(reorderedTopics.map((t, idx) => ({ id: t.id, position: idx }))));
  
    const res = await axios.post(ENDPOINT + 'admin-update-topic-order.php', formData, {
      headers: { 'content-type': 'multipart/form-data' },
    });
  
    if (res.data.status !== 'success') {
      console.error('Failed to update order:', res.data.message);
     
      getTopics(); 
    }
  };

  useEffect(() => {
    getTopics();
  }, []);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  return (
    <>
      <div className="toast-container">
        <Toast className="bg-warning" onClose={() => setToast(false)} show={toast} delay={3000} autohide>
          <Toast.Header>
            <strong className="me-auto">{toastTitle}</strong>
          </Toast.Header>
        </Toast>
      </div>

      <Modal open={edit} sx={ModalStyle} onClose={() => setEdit(false)}>
        <Box sx={{ ...style, width: 500 }}>
          <p>Title:</p>
          <input className="form-control" type="text" value={ctTitle} onChange={(e) => setCtTitle(e.target.value)} />
          <p>Cover Pic:</p>
          <input className="form-control" type="file" onChange={onChange} />
          {file && <img src={URL.createObjectURL(file)} className="w-100 mt-2 mb-2" alt="preview" />}
          <button className="btn btn-primary w-100 mt-3" onClick={() => EditTopic({ payload: { cover_pic: file } })}>
            Save Changes
          </button>
        </Box>
      </Modal>

      <Modal open={add} sx={ModalStyle} onClose={() => setAdd(false)}>
        <Box sx={{ ...style, width: 500 }}>
          <p>Add Topic</p>
          <input className="form-control" type="text" value={ctTitle} onChange={(e) => setCtTitle(e.target.value)} />
          <p>Cover Pic:</p>
          <input className="form-control" type="file" onChange={onChange} />
          <p>Topic ID:</p>
          <input className="form-control" value={ctId} type="number" onChange={(e) => setCtId(e.target.value)} />
          <button className="btn btn-primary w-100 mt-3" onClick={addTopicDB}>
            Add Topic
          </button>
        </Box>
      </Modal>

      <div className="container-fluid mt-3">
        <div className="flex-wrap d-flex justify-content-between">
          <h1>Topic Management</h1>
          <button onClick={addTopic} className="btn bg-primary h-fit text-white">
            Add Topic
          </button>
        </div>
        <hr />
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="topics">
            {(provided) => (
              <div className="d-flex flex-wrap" {...provided.droppableProps} ref={provided.innerRef}>
                {topics ? (
                  topics.map((topic, index) => (
                    <Draggable key={topic.id} draggableId={topic.id.toString()} index={index}>
                      {(provided) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 p-2  mt-5"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div className="shadow rounded p-3 d-flex d-sm-block d-md-block d-lg-block">
                            <div className="width-class-25">
                              <img src={topic.cover_image} className="w-100 h-100" alt="cover" />
                            </div>
                            <div className="d-flex flex-row width-class-75">
                              <div className="mt-0 mt-sm-3 ml-2 ml-sm-0 w-100">
                                <h6>
                                  {index + 1}.{topic.topic_title}
                                </h6>
                                <p className="mb-0">{topic.description}</p>
                              </div>
                              <div className="mt-0 mt-sm-3">
                                <Dropdown className="options-dropdown">
                                  <Dropdown.Toggle className="bg-dark options p-0 w-fit h-fit border-0">
                                    <MoreVert className="text-dark" />
                                  </Dropdown.Toggle>
                                  <DropdownMenu>
                                    <DropdownItem onClick={() => StartEdit(topic.id, index)}>
                                      <Edit className="mr-2" /> Edit
                                    </DropdownItem>
                                    <DropdownItem onClick={() => deleteTopic({ topic })}>
                                      <DeleteIcon className="mr-2" /> Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))
                ) : (
                  'no topics'
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
};

export default CourseTopicsManagement;